import instance from '../../utils/axiosConfig';

/**
 * 사용자 정보 조회 API
 * @param {Object} [params] - 쿼리 파라미터
 * @returns {Promise} API 응답 - 사용자 정보
 */
export const getMyInfo = async (params) => {
    try {
        const response = await instance.get('/api/v1/auth/me', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * 토큰 유효성 검사 API
 * @returns {Promise} API 응답 - 토큰 유효성 결과
 */
export const checkIfTokenIsValid = async () => {
    try {
        const response = await instance.get('/api/v1/auth/token/valid');
        return response.data;
    } catch (error) {
        throw error;
    }
};
